import React from 'react';

export default function ChatNotSelected() {
  return (
        <div className='chat-not-selected'>
            <span className="chat-not-selected-text">
                Оберіть чат для початку листування
            </span>
        </div>
  );
}